import { Difficulty } from "./config";

const HIGH_SCORE_EASY = "highscore_easy";
const HIGH_SCORE = "highscore";

const checkHighScore = (score: number, difficulty: Difficulty = "hard") => {
  const highScoreKey = difficulty === "easy" ? HIGH_SCORE_EASY : HIGH_SCORE;
  const currentHighScore = localStorage.getItem(highScoreKey);
  if (!currentHighScore || parseInt(currentHighScore, 10) < score) {
    localStorage.setItem(highScoreKey, score.toString());
    return true;
  }
  return false;
};

export default {
  checkHighScore,
};
